import {InlineInput} from "../../../../../../../components/general/InlineInput.tsx";
import {MoneyInput} from "../../../../../../../components/general/MoneyInput/MoneyInput.tsx";
import {DeleteRowButton} from "../../../../../../../views/DocumentDrawer/components/LineItemsRow.tsx";
import type {CreditCardStatementLine} from "../../types.ts";
import {CREDIT_CARD_SETTLEMENT_CURRENCY} from "./utils/creditCardSettlementUtils.ts";

interface CreditCardStatementLinesEditorProps {
    statementLines: CreditCardStatementLine[];
    onUpdateLine: (key: number, patch: Partial<CreditCardStatementLine>) => void;
    onRemoveLine: (key: number) => void;
}

const inlineMoneyClassName =
    "w-full bg-transparent border-0 text-sm focus:border focus:border-gray-400 focus:rounded focus:bg-white focus:outline-none focus:ring-0 cursor-text hover:bg-gray-50 transition-colors";

const inlineDateClassName =
    "w-full bg-transparent border-0 text-sm focus:border focus:border-gray-400 focus:rounded focus:bg-white focus:outline-none focus:ring-0 cursor-text hover:bg-gray-50 transition-colors";

export function CreditCardStatementLinesEditor({
    statementLines,
    onUpdateLine,
    onRemoveLine,
}: CreditCardStatementLinesEditorProps) {
    return (
        <div className="overflow-x-auto">
            <table className="w-full min-w-[640px] border-separate border-spacing-y-2 text-sm">
                <thead>
                    <tr>
                        <th className="rounded-l-lg bg-gray-100 px-4 py-2 text-left font-medium text-gray-700">
                            Relatie <span className="text-red-600">*</span>
                        </th>
                        <th className="bg-gray-100 px-4 py-2 text-left font-medium text-gray-700">
                            Omschrijving <span className="text-red-600">*</span>
                        </th>
                        <th className="bg-gray-100 px-4 py-2 text-left font-medium text-gray-700">
                            Bedrag (EUR) <span className="text-red-600">*</span>
                        </th>
                        <th className="bg-gray-100 px-4 py-2 text-left font-medium text-gray-700">
                            Datum <span className="text-red-600">*</span>
                        </th>
                        <th className="w-12 rounded-r-lg bg-gray-100 px-2 py-2" />
                    </tr>
                </thead>
                <tbody>
                    {statementLines.map((line) => (
                        <tr key={line.key}>
                            <td className="rounded-l-lg bg-gray-100 px-4 py-3 align-middle">
                                <InlineInput
                                    type="text"
                                    placeholder="Relatie"
                                    value={line.relationName}
                                    onChange={(event) => onUpdateLine(line.key, {relationName: event.target.value})}
                                />
                            </td>
                            <td className="bg-gray-100 px-4 py-3 align-middle">
                                <InlineInput
                                    type="text"
                                    placeholder="Omschrijving"
                                    value={line.description}
                                    onChange={(event) => onUpdateLine(line.key, {description: event.target.value})}
                                />
                            </td>
                            <td className="bg-gray-100 px-4 py-3 align-middle">
                                <MoneyInput
                                    value={line.amount}
                                    currency={CREDIT_CARD_SETTLEMENT_CURRENCY}
                                    className={inlineMoneyClassName}
                                    selectOnFocus
                                    onChange={(money) => onUpdateLine(line.key, {amount: money})}
                                />
                            </td>
                            <td className="bg-gray-100 px-4 py-3 align-middle">
                                <input
                                    type="date"
                                    value={line.bookingDate}
                                    className={inlineDateClassName}
                                    onChange={(event) => onUpdateLine(line.key, {bookingDate: event.target.value})}
                                />
                            </td>
                            <td className="rounded-r-lg bg-gray-100 px-2 py-3 align-middle">
                                <DeleteRowButton
                                    onDelete={() => {
                                        if (statementLines.length > 1) {
                                            onRemoveLine(line.key);
                                        }
                                    }}
                                />
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}
